export default "__VITE_ASSET__Cw90Ii0G__";